module.exports = __webpack_public_path__ + "img/MoonSword 6.725931a9.png";